import React, { useState } from "react";
import styled from "styled-components";
import Switch from "react-switch";
import day from "../Icons/day.svg";
import night from "../Icons/night.svg";
import "./navbar.css"
// import { Translate } from "@material-ui/icons";
import { Link } from 'react-router-dom';
// import CloseIcon from '@mui/icons-material/Close';
// import {ReorderIcon} from '@mui/icons-material/Reorder';
// import { FaBars } from 'react-icons/fa';

const NavBar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
   position: fixed;
  //  top:0;
  justify-content: space-between;
  height: 7vh;
  z-index: 1000;
  transition: all 300ms ease-out;
  /* background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.fontColor}; */
  background-color: inherit;
  color: inherit;
  @media screen and (max-width:1040px) {
    .list{
        flex-direction: column;
        justify-content: center;
        align-items: center;
width: 100%;
height: 100vh;
/* background-color:white; */

/* border: solid 1px; */
position: absolute;
top: 0;
left: -100%;
z-index: -3;
transition: 0.3s;



    }
    .list.active{
        left: 0;
        z-index:3;

        height: 30em;
        top: 4em;
        backdrop-filter:blur(10px);
        position: absolute;
    }
    .list li{
        padding: 1rem 0;

    }
    
    .list li a{
        font-size: 1.8rem;
    }
    .icons{
        font-size: 2rem;
    }
    .hamburger{
        display: initial;
    }
}
`;

const NavItem = styled.div`
  margin: 0 1%;
  display: flex;
  align-items: center;
  > a {
    text-decoration: none;
    font-size: 17px;
    color: inherit;
    text-transform: uppercase;
    font-family: ${(props) => props.theme.font};
    font-weight: 600;
  }
  img {
    width: 30px;
    margin-right: 10px;
  }
  @media (max-width: 350px) {
    img {
      display: none;
    }
  }

  @media (max-width: 750px) {
    margin: 9px;
    a {
      font-size: 14px;
    }
  }
`;

const Grow = styled.div`
  flex-grow: 1;
  @media (max-width: 600px) {
    display: none;
  }
`;

function Navigation({ themeToggler, currentTheme }) {
  const [activeLink, setActiveLink] = React.useState(3);
  const [toggle, setToggle] = React.useState(false);
  const activeLinkHandler = (linkNo) => {
    setActiveLink(linkNo);
  };

  const switchHandler = () => {
    setToggle((prev) => !prev);
    themeToggler();
  };
  const [clicked,setClicked] = useState(false)
  const handleClick = ()=>{
      setClicked(!clicked)

  }
  return (
    <NavBar active={activeLink} style={{background:"black"}}>

      <Grow></Grow>
      
      <ul className={clicked?"list active":"list"}>

<li><a href="#home" onClick={()=>activeLinkHandler(1)} className='links'> Home</a><Link> </Link></li>
<li><a href="#about" onClick={()=>activeLinkHandler(2)}className='links'>About Me</a></li>

<li><a href="#skill" onClick={()=>activeLinkHandler(3)} className='links'>Skils</a></li>

<li><a href="https://drive.google.com/file/d/1q9de96w-8tL1qUU7e8jeESLIO8Jjm2Fz/view?usp=share_link" target = "_blank"  rel = "noreferrer"className='links'>Resume</a></li>



<li><a href="#contact" onClick={()=>activeLinkHandler(5)} className='links'>Contact</a></li>


</ul>
<div className='hamburger' onClick={handleClick} >

            {clicked ?
(<p>close</p>):
(<p>open</p>)
        }
        </div>



      {/* <NavItem>
        <Switch
          onChange={switchHandler}
          handleDiameter={20}
          checked={toggle}
          onColor="#fff"
          offColor="#fff"
          offHandleColor="#0A192F"
          onHandleColor="#000000"
          checkedHandleIcon={
            <div style={{ position: "relative", overflow: "hidden" }}>
              <img
                style={{
                  objectFit: "contain",
                  width: "60%",
                  overflow: "hidden",
                  padding: "4px",
                }}
                src={night}
                alt="night"
              ></img>
            </div>
          }
          uncheckedHandleIcon={
            <div style={{ overflow: "hidden" }}>
              <img
                style={{
                  objectFit: "contain",
                  width: "60%",
                  overflow: "hidden",
                  padding: "4px",
                }}
                src={day}
                alt="day"
              ></img>
            </div>
          }
        />
      </NavItem>
      <NavItem></NavItem> */}

    </NavBar>
  );
}

export default Navigation;
